<div class="modal-header">
    <h2 class="modal-title" id="modal-title">{{ header }}</h2>
</div>

<rask-container-block>
    {{ message }}
</rask-container-block>

<rask-button
    class="footer-button"
    color="secondary"
    (click)="setResponse(false)">
    Avbryt
</rask-button>

<rask-button
    class="footer-button"
    color="primary"
    (click)="setResponse(true)">
    Ok
</rask-button>